import AllocateSalesOrdersMutation from '../../graphql/mutations/sales/AllocateSalesOrdersMutation.graphql';
import React, { useContext } from 'react';
import WorkspaceContext from '../../components/Context/WorkspaceContext';
import { Allocation, SalesOrder } from '../../graphql/entities';
import { useBackgroundMutation } from '../../utils/BackgroundJobs';
import LinkNotification from '../../components/Notification/LinkNotification';
import { ActionButton } from '../../components/connectedForm/Button/Button';
import { useActionCriteria } from '../../utils/useActionProps';
import { useP4ToastController } from '../../views/system/NotificationsArea';
import { AlertType } from '../../graphql/schema/p4types';
import normalizeVariables from '../../graphql/schema/normalizeVariables';
import getClientMutationId from '../../utils/getClientMutationId';

export const AllocateWorkspaceAction = ({
  mutation = AllocateSalesOrdersMutation,
  type = 'salesOrders',
  title = 'Allocating Orders',
}) => {
  const workspaceContext = useContext(WorkspaceContext);
  const actionCriteria = useActionCriteria();

  const { dispatchToast, dismissToast } = useP4ToastController();

  const [allocateSalesOrders] = useBackgroundMutation(mutation, {
    jobTitle: title,
    errorOptions: { entity: SalesOrder, name: 'Could not allocate orders' },
    onCompleteJob: (job) => {
      workspaceContext.reloadData(true).catch(() => {
        // Do nothing following workspace reload, notification can display without waiting.
      });

      const stockAllocationToastId = `${job.jobId}-result`;

      dispatchToast(
        <LinkNotification
          job={job}
          type={job.recordsFailed < job.recordCount ? AlertType.Success : AlertType.Warning}
          title={'Stock allocation'}
          message={
            job.message ??
            (job.recordsFailed > 0
              ? `Allocation job has completed with ${job.recordsFailed} failure(s) out of ${job.recordCount} total records processed.`
              : 'Allocation job has completed.')
          }
          link={`${Allocation.workspaceUrl}${job.jobId}`}
          linkTitle={'View Allocations'}
          onClose={() => {
            dismissToast(stockAllocationToastId);
          }}
        />,
        {
          title: 'Stock allocation completed',
          type: AlertType.Action,
          toastId: stockAllocationToastId,
          intent: 'success',
        }
      );
    },
  });

  const onClick = () => {
    allocateSalesOrders({
      variables: {
        input: {
          filters: actionCriteria.filters,
          [type]: normalizeVariables(actionCriteria.actionEntities),
          include: actionCriteria.include,
          clientMutationId: getClientMutationId(),
        },
      },
    });
  };

  return <ActionButton label={'Allocate'} onClick={onClick} />;
};
